import { ThemeColors } from '~/themes/colors'

interface CallButtonColors {
  Icon: ThemeColors
  Variants: {
    Start: {
      Background: ThemeColors
      Hover: {
        Background: ThemeColors
      }
      Active: {
        Background: ThemeColors
      }
    }
    Disabled: {
      Background: ThemeColors
    }
    End: {
      Background: ThemeColors
      Hover: {
        Background: ThemeColors
      }
    }
  }
}

export const callButtonColors: CallButtonColors = {
  Icon: {
    default: 'white',
  },
  Variants: {
    Start: {
      Background: {
        default: 'blue.900',
      },
      Hover: {
        Background: {
          default: 'blue.900',
        },
      },
      Active: {
        Background: {
          default: 'blue.1100',
        },
      },
    },
    Disabled: {
      Background: {
        default: 'gray.600',
      },
    },
    End: {
      Background: {
        default: 'red.800',
      },
      Hover: {
        Background: {
          default: 'red.900',
        },
      },
    },
  },
}
